<template lang="pug">

  div
    Header
    router-view
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Shop',
  components: {
    Header
  }
}
</script>

